// extracted by mini-css-extract-plugin
export default {"mlDecoratesCollapseWrap":"mailList-module--ml-decorates-collapse-wrap--Z7EtU"};